export enum ESystemNoticeSeverity {
    Info,
    Warning,
    Error,
    Critical
}

export enum ESystemNoticeType {
    Auth,
    General
}

export type TSystemNoticeSeverity = 
    ESystemNoticeSeverity.Info | ESystemNoticeSeverity.Warning | ESystemNoticeSeverity.Error | ESystemNoticeSeverity.Critical;

export type TSystemNoticeType = 
    ESystemNoticeType.General | ESystemNoticeType.Auth;

export interface ISystemNotice {
    
    // nevet tegyünk ide, ha van ilyen
    name?: string;

    // forrást tegyük ide, ha van ilyen
    source?: string;

    message: string;

    severity: TSystemNoticeSeverity;
    
    type: TSystemNoticeType;

    timestamp?: Date;

    seen?: boolean;
    
}